// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2QI_2","footer":"Form_footer__2kDU4"};